import styled from 'styled-components';

export const MyAppsContainer = styled.div`
  display: flex;
  height: 100%;
  gap: 16px;
`;

export const MyAppsContent = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 60px 40px 24px;

  display: flex;
  flex-direction: column;
`;
